/// <amd-module name="VSSUI/Components/Card/CardContent" />
import * as React from "react";

import { SurfaceContext } from "VSSUI/Surface";

import { ICardContentProps } from "./Card.Props";

import { css } from "VSSUI/Util";

export const CardContent: React.SFC<ICardContentProps> = props => {
    return (
        <SurfaceContext.Consumer>
            {surfaceContext => {
                const { contentPadding = true } = props;
                return (
                    <div
                        className={css(props.className, "bolt-card-content flex-row flex-grow", contentPadding && surfaceContext.horizontalClassName)}
                    >
                        {props.children}
                    </div>
                );
            }}
        </SurfaceContext.Consumer>
    );
};
